import React from 'react';
import { Label } from './ui/label';
import { Button } from './ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { FiPlus } from 'react-icons/fi';

/**
 * Select with a "Manage" (+) button that opens a CRUD dialog.
 * Used in Registros for Forma de Pagamento, Banco and Categoria.
 */
export const SelectWithAdd = ({ label, value, onChange, options, onManage, testIdSelect, testIdManage }) => (
  <div>
    <Label className="text-blue-900 font-semibold">{label}</Label>
    <div className="flex gap-2 mt-1">
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid={testIdSelect} className="flex-1">
          <SelectValue placeholder="Selecione" />
        </SelectTrigger>
        <SelectContent>
          {options.length === 0 && (
            <div className="px-2 py-1.5 text-xs text-slate-500">Nenhum cadastrado</div>
          )}
          {options.map((o) => (
            <SelectItem key={o.id || o.name} value={o.name}>
              <div className="flex items-center gap-2">
                {o.color && (
                  <span
                    className="w-2.5 h-2.5 rounded-full flex-shrink-0 shadow-2xs border border-black/10"
                    style={{ backgroundColor: o.color }}
                  />
                )}
                <span className="truncate">{o.name}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button
        data-testid={testIdManage}
        type="button"
        variant="outline"
        size="icon"
        className="flex-shrink-0"
        onClick={onManage}
        title={`Gerenciar ${label}`}
      >
        <FiPlus size={16} />
      </Button>
    </div>
  </div>
);

export default SelectWithAdd;
